"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/aboutUs.tsx */

import { SmartImage } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutUs4sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "1.8s" */
    dataWowDuration: string;
    /** Detected variants: "Lives Transformed" | "Years Experience" | "Client Rating" */
    p0Text: ReactNode;
    /** Detected variants: "col-sm-4" */
    className?: string;
    /** Detected variants: "counter-item-sixteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "count" */
    h30ClassName?: string;
    /** Detected variants: "inView && (\n                          <>\n                            <CountUp end={2500} duration={2} separator=\",\" />+\n                          </>\n                        )" | "inView && (\n                          <>\n                            <CountUp end={18} duration={2} />+\n                          </>\n                        )" | "inView && (\n                          <>\n                            <CountUp end={4.9} duration={2} decimals={1} />\n                            /5\n                          </>\n                        )" */
    div0h30Expr0: ReactNode;
};

type AboutUsHorizontalSlideSlideSixteen4FadeInDownsItem = {
    key: Key | null | undefined;
    /** Detected variants: "horizontal-slide slide-sixteen d-flex mb-4 wow fadeInDown" | "horizontal-slide slide-sixteen d-flex wow fadeInDown" */
    className: string;
    /** Detected variants: "left" | "right" */
    dataDirection: string;
    /** Detected variants: "1s" | "1.5s" */
    dataWowDuration: string;
    /** Detected variants: "slow" */
    dataSpeed?: string;
    slideListItems?: AboutUsServicesSlidesItem[];
};

type AboutUsServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/about/about-thumb-1.jpg" | "/Templates/Doccure/img/about/about-thumb-2.jpg" | "/Templates/Doccure/img/about/about-thumb-3.jpg" | "/Templates/Doccure/img/about/about-thumb-4.jpg" | "/Templates/Doccure/img/about/about-thumb-5.jpg" | "/Templates/Doccure/img/about/about-thumb-6.jpg" | "/Templates/Doccure/img/about/about-thumb-7.jpg" | "/Templates/Doccure/img/about/about-thumb-8.jpg" */
    src: string;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "about" */
    alt?: string;
    /** Detected variants: "img-fluid about-img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "() => openLightbox(0)" | "() => openLightbox(1)" | "() => openLightbox(2)" | "() => openLightbox(3)" | "() => openLightbox(4)" | "() => openLightbox(5)" | "() => openLightbox(6)" | "() => openLightbox(7)" */
    onClick: string;
};
export type HomeSixteenAboutUsGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutUs4sItem) => Partial<ComponentProps<"h3">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutUsServicesSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "About Us" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "We are dedicated to helping individuals achieve their" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    /** Default: "personalized Expert" */
    sectionDiv0Div0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "wellness goals through" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div0Div1Div0Div0ClassName?: string;
    /** Default: "Our mission is to make nutrition simple, accessible, and effective for everyone. Whether you're looking to improve your daily diet, manage your weight, enhance fitness performance, or support long-term health." */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    aboutUs4s: AboutUs4sItem[];
    aboutUsHorizontalSlideSlideSixteen4FadeInDowns: AboutUsHorizontalSlideSlideSixteen4FadeInDownsItem[];
    aboutUs4sItemWrapper?: (item: AboutUs4sItem, content: ReactNode) => ReactNode;
    aboutUs4sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutUs4sH3Visible?: boolean;
    aboutUs4sH3Renderer?: (item: AboutUs4sItem, defaultNode: ReactNode) => ReactNode;
    aboutUs4sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutUs4sItem) => Partial<ComponentProps<"h3">>);
    aboutUsHorizontalSlideSlideSixteen4FadeInDownsItemWrapper?: (item: AboutUsHorizontalSlideSlideSixteen4FadeInDownsItem, content: ReactNode) => ReactNode;
    aboutUsHorizontalSlideSlideSixteen4FadeInDownsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutUsServicesSlidesItemWrapper?: (item: AboutUsServicesSlidesItem, content: ReactNode) => ReactNode;
    aboutUsServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutUsServicesSlidesImageVisible?: boolean;
    aboutUsServicesSlidesImageRenderer?: (item: AboutUsServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    aboutUsServicesSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutUsServicesSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeSixteenAboutUsGenerated: FC<HomeSixteenAboutUsGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Div0DivText = "About Us",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H20H2Text = "We are dedicated to helping individuals achieve their",
    sectionDiv0Div0Div0Div0H20H2Text2 = "personalized Expert",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "wellness goals through",
    sectionDiv0Div0Div1Div0P0PText = "Our mission is to make nutrition simple, accessible, and effective for everyone. Whether you're looking to improve your daily diet, manage your weight, enhance fitness performance, or support long-term health.",
    divDiv0H30H3Props,
    divImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div0Div0ClassName,
    aboutUs4s,
    aboutUsHorizontalSlideSlideSixteen4FadeInDowns,
    aboutUs4sItemWrapper,
    aboutUs4sRenderer,
    aboutUs4sH3Visible,
    aboutUs4sH3Renderer,
    aboutUs4sH3Props,
    aboutUsHorizontalSlideSlideSixteen4FadeInDownsItemWrapper,
    aboutUsHorizontalSlideSlideSixteen4FadeInDownsRenderer,
    aboutUsServicesSlidesItemWrapper,
    aboutUsServicesSlidesRenderer,
    aboutUsServicesSlidesImageVisible,
    aboutUsServicesSlidesImageRenderer,
    aboutUsServicesSlidesImageProps,
}) => {
    const resolveGeneratedOnClick = (value?: string | (() => void)) => {
        if (typeof value === "function") {
            return value;
        }

        if (!value) {
            return undefined;
        }

        const match = value.match(/(?:onOpenLightbox\?\.\(|openLightbox\()(\d+)\)/);
        if (!match) {
            return undefined;
        }

        const index = Number(match[1]);
        return () => onOpenLightbox?.(index);
    };
    return (
        <>
            <section className="section about-section-sixteen">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-xl-6">
                            <div className="section-header-sixteen one wow fadeInDown" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                                <div className="sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                        {sectionDiv0Div0Div0Div0H20H2Text}
                                        {" "}
                                        <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                        {sectionDiv0Div0Div0Div0H20H2Text2}
                                    </h2>
                                ))}
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="section-header-sixteen text-end">
                                <p className="description">{sectionDiv0Div0Div1Div0P0PText}</p>
                                <div className={sectionDiv0Div0Div1Div0Div0ClassName ?? "row row-gap-4 counter-group-sixteen"}>
                                    {renderCollectionNode(
                                        aboutUs4s,
                                        (item: AboutUs4sItem) => (
                                            <div className={item.className ?? "col-sm-4"} key={item.key}>
                                                <div className={item.div0ClassName ?? "counter-item-sixteen wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                                    {renderItemNode(aboutUs4sH3Visible, aboutUs4sH3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "count"} {...(typeof aboutUs4sH3Props === "function" ? aboutUs4sH3Props(item) : (aboutUs4sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}></h3>
                                                    ))}
                                                    <p>{item.p0Text}</p>
                                                </div>
                                            </div>
                                        ),
                                        aboutUs4sItemWrapper,
                                        aboutUs4sRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderCollectionNode(
                    aboutUsHorizontalSlideSlideSixteen4FadeInDowns,
                    (item: AboutUsHorizontalSlideSlideSixteen4FadeInDownsItem) => (
                        <div className={item.className} data-wow-duration={item.dataWowDuration} data-direction={item.dataDirection} data-speed={item.dataSpeed ?? "slow"} key={item.key}>
                            <div className="slide-list d-flex gap-4">
                                {renderCollectionNode(
                                    item.slideListItems ?? [],
                                    (item: AboutUsServicesSlidesItem) => (
                                        <div className={item.className ?? "services-slide"} onClick={resolveGeneratedOnClick(item.onClick)} style={{ cursor: "pointer" }} key={item.key}>
                                            {renderItemNode(aboutUsServicesSlidesImageVisible, aboutUsServicesSlidesImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "about"} className={item.imageWithBasePath0ClassName ?? "img-fluid about-img-one"} {...(typeof aboutUsServicesSlidesImageProps === "function" ? aboutUsServicesSlidesImageProps(item) : (aboutUsServicesSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    ),
                                    aboutUsServicesSlidesItemWrapper,
                                    aboutUsServicesSlidesRenderer
                                )}
                            </div>
                        </div>
                    ),
                    aboutUsHorizontalSlideSlideSixteen4FadeInDownsItemWrapper,
                    aboutUsHorizontalSlideSlideSixteen4FadeInDownsRenderer
                )}
            </section>
            <Lightbox isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} images={lightboxSlides} currentIndex={lightboxIndex ?? 0} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeSixteenAboutUsGenerated;
